import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { List } from 'foundations-components/transitional/components/List';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import ProductIcon from '../common/ProductIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StarterCustomerPlatformUpsellCardBusinessObjectives = ({
  currentProductLine
}) => {
  // display all product lines except the current product line (the hub page you are on)
  const DisplayedProductLines = AllProductLines.filter(productLine => productLine !== currentProductLine);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PPUIGridItem, {
      paddingBlockStart: "800",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `merchCards.starterCustomerPlatformUpsellCard.businessObjectives.header.${currentProductLine}`
      })
    }), /*#__PURE__*/_jsx(PPUIGridItem, {
      paddingBlockEnd: "600",
      children: /*#__PURE__*/_jsx(List, {
        children: DisplayedProductLines.map(localProductLine => {
          return /*#__PURE__*/_jsxs(Flex, {
            marginBlock: "300",
            alignItems: "start",
            children: [/*#__PURE__*/_jsx(ProductIcon, {
              name: localProductLine,
              iconStyle: {
                blockSize: '24px',
                marginInlineEnd: '300'
              }
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(Text, {
                typography: "body-125",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `merchCards.starterCustomerPlatformUpsellCard.businessObjectives.${localProductLine}.title`
                })
              }), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `merchCards.starterCustomerPlatformUpsellCard.businessObjectives.${localProductLine}.subtext`
                })
              })]
            })]
          }, localProductLine);
        })
      })
    })]
  });
};
export default StarterCustomerPlatformUpsellCardBusinessObjectives;